import { render, staticRenderFns } from "./ColumnHeader.vue?vue&type=template&id=2aadf2ad&scoped=true"
import script from "./ColumnHeader.vue?vue&type=script&lang=js"
export * from "./ColumnHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aadf2ad",
  null
  
)

export default component.exports